;(function($) {
	$(document).ready(function() {
		var start = 0;
		var end = 0;

		$(document).on('click', 'a[data-pjax]', function(event) {
			var $this = $(this);

			var options = { push: Boolean($this.data('pjaxPush')) };

			if ( typeof $this.data('pjaxScroll') !== 'undefined' ) {
				options.scrollTo = $this.data('pjaxScroll');
			}

			if ( $this.data('confirm') ) {
				bootbox.confirm($this.data('confirm'), function(result) {
					if (result) {
						// need to do this because bootbox prevent default on event
						event.isDefaultPrevented = function(){ return false; };

						$.pjax.click(event, options);
					}
				});

				return false;
			}

			return $.pjax.click(event, options);
		});

		$(document).on('click', 'form[data-pjax] [type="submit"]', function() {
			$(this).closest('form').append('<input type="hidden" name="' + this.name + '" value="' + this.value + '" />');
		});

		$(document).on('submit', 'form[data-pjax]', function(event) {
			var $this  = $(this);
			var container = $this.data('pjax');
			$(container).removeClass('d-none').show();

			return $.pjax.submit(event, container, {
				push: Boolean($this.data('pjaxPush')),
				scrollTo: Boolean($this.data('scrollTo')) === false ? false : 0,
			});
		});

		$(document).on('click', '[data-close]', function(event) {
			$($(this).data('close')).empty();
		});

		$(document).on('pjax:beforeSend', function(event) {
			// store start time
			start = new Date().getTime();

			var $source = $(event.relatedTarget);
			var $target = $(event.target);

			if (! $target.hasClass('has-placeholder')) {
				$source.addClass('disabled pjax spinner');
			}

			$target.addClass('pjax loading').removeClass('d-none');

			// fire pjax.beforeSend event
			fire('pjax.beforeSend', event);
		});

		$(document).on('pjax:success', function(event) {
			// prepend close button
			if ( event.relatedTarget && event.relatedTarget.dataset.pjaxClose ) {
				$(event.relatedTarget.dataset.pjax).prepend('<div class="row-fluid"><a href="#close" class="close" title="Close" data-close="' + event.relatedTarget.dataset.pjax + '">&times;</a></div>');
			}

			// store end time
			end = new Date().getTime();

			$(document).trigger('pjax:server:response:time', (end - start) / 1000 );

			// fire pjax.success event
			fire('pjax.success', event);
		});

		$(document).on('pjax:error', function(event) {
			// fire pjax.error event
			fire('pjax.error', event);
		});

		$(document).on('pjax:complete', function(event) {
			$(event.relatedTarget).removeClass('disabled pjax spinner');
			$(event.target).removeClass('pjax loading');

			// fire pjax.complete event
			fire('pjax.complete', event);
		});

		$(document).on('pjax:timeout', function(event) {
			// Prevent default timeout redirection behavior
			event.preventDefault();
		});
	});

	function fire(eventType, event) {
		// trigger eventType on related target
		$(event.relatedTarget).trigger( eventType, 'relatedTarget' );
		// trigger eventType on target
		$(event.target).trigger( eventType, 'target' );
	}
})(jQuery);
